export default __webpack_public_path__ + "static/media/arrow-up-light.74b1564e.svg";